import * as tinyJest from "./index";
//@ts-ignore
window["tinyJest"] = tinyJest;
